

























import { Vue, Component, Prop } from 'vue-property-decorator';
import { mdbRow, mdbCol, mdbInput } from '@folky-tools/mdbvue';
import { Link } from '@/models/common/link';

@Component({
    components: {
        mdbRow,
        mdbCol,
        mdbInput
    },
    validations: {
        links: {
            $each: {
                isValid: (link): boolean => {
                    if (link.isWhatsApp && link.url) {
                        return /^\d{9}$/.test(link.url);
                    }

                    return true;
                }
            }
        }
    }
})
export default class EditSocialMediaLinks extends Vue {
    @Prop(Array) private links!: Link[];

    private hasErrors(): boolean {
        this.$v.links.$touch();
        if (this.$v.links.$anyError) {
            return true;
        }
        return false;
    }
}
